import React, { useEffect } from "react";
import { useApplication } from "../../contexts/ApplicationContext";
import { EventView } from "../../views/event/EventView";
import { useEvent } from "../../contexts/EventContext";
import { useServices } from "../../contexts/ServiceContext";
import { Splash404 } from "../../views/splash/Splash404";

export const EventController = (): JSX.Element => {
    const {
        appState: { currentEventId, freeplayFocusedExperience404 },
        appDispatch,
    } = useApplication();
    const { currentEvent, getEventInfo } = useEvent();
    const { fpUser } = useServices();
    const {
        appState: { focusedEventId },
    } = useApplication();

    useEffect(() => {
        if (currentEventId >= 0) {
            getEventInfo(currentEventId);
        } else if (currentEvent) {
            getEventInfo(currentEvent.id);
        }

        //Focused experience
        if (!fpUser && focusedEventId) {
            getEventInfo(parseInt(focusedEventId))
                .then(() => {
                    appDispatch({ type: "setHeaderVisible", headerVisible: true });
                })
                .catch(() => {
                    appDispatch({ type: "setHeaderVisible", headerVisible: false });
                    appDispatch({ type: "setFreeplayFocusedExperience404", freeplayFocusedExperience404: true });
                });
        } else if (focusedEventId && fpUser) {
            getEventInfo(parseInt(focusedEventId))
                .then(() => {
                    appDispatch({ type: "setHeaderVisible", headerVisible: true });
                })
                .catch(() => {
                    appDispatch({ type: "setHeaderVisible", headerVisible: false });
                    appDispatch({ type: "setFreeplayFocusedExperience404", freeplayFocusedExperience404: true });
                });
        }

        // This needs to be tested in focus mode.

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fpUser]);

    useEffect(() => {
        if (currentEvent) {
            appDispatch({ type: "setPageTitle", pageTitle: currentEvent.name });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentEvent]);

    if (freeplayFocusedExperience404) {
        return <Splash404 />;
    }
    if (!currentEvent) {
        return <></>;
    }

    return <EventView />;
};
